function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2d52"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2d52"] = parcelRequire;
}
parcelRequire.register("kucSS", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $eea09a8424a19ed1$export$6503ec6e8aabbaf; }, function (v) { return $eea09a8424a19ed1$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $eea09a8424a19ed1$export$f7ad0328861e2f03; }, function (v) { return $eea09a8424a19ed1$export$f7ad0328861e2f03 = v; });
var $eea09a8424a19ed1$export$6503ec6e8aabbaf;
var $eea09a8424a19ed1$export$f7ad0328861e2f03;
"use strict";
var $eea09a8424a19ed1$var$mapping = {};
function $eea09a8424a19ed1$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$eea09a8424a19ed1$var$mapping[keys[i]] = pairs[keys[i]];
}
function $eea09a8424a19ed1$var$resolve(id) {
    var resolved = $eea09a8424a19ed1$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$eea09a8424a19ed1$export$6503ec6e8aabbaf = $eea09a8424a19ed1$var$register;
$eea09a8424a19ed1$export$f7ad0328861e2f03 = $eea09a8424a19ed1$var$resolve;

});

var $81d1fae78e8ff53d$exports = {};

(parcelRequire("kucSS")).register(JSON.parse('{"9ihU6":"index.2a377b6c.js","ePi3T":"applicationinsights-react-js.089493fe.js","2ykam":"applicationinsights-react-js.f29d54fb.js","3m2Ud":"applicationinsights-react-js.9ae75e8b.js","f2l39":"applicationinsights-web.ad88997e.js","7Akxb":"applicationinsights-web.44fa2031.js","1tDHl":"applicationinsights-clickanalytics-js.9f0c3586.js","lrtFF":"apple-touch-icon.176c0538.png","cdcGZ":"favicon.561cee98.png","csIrZ":"index.384058cf.css"}'));


//# sourceMappingURL=index.214fe55d.js.map
